import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { DistanceService } from './distanceService';

@Injectable()
export class Co2Service {

  constructor(
    private configService: ConfigService,
    private distanceService: DistanceService
  ) {}

  async calculateCO2(departure_id: number, arrival_id: number, quantity: number, etapePorteur1: number, etapePorteur2: number): Promise<number> {
   const distance = await this.calculateDistance(departure_id, arrival_id);
    //const etapePorteur1 = this.new_planning.get('planning_emit.etape_porteur_1').value;
    //const etapePorteur2 = this.new_planning.get('planning_emit.etape_porteur_2').value;
    
    
    let co2Emission = 0;

    if (quantity > 20 && quantity <= 33) {
      // Camion complet
      co2Emission = await this.calculateFullTruckCO2(distance)
      
    } else if (quantity < 20) {
      // Groupage
      co2Emission = await this.calculateGroupedTruckCO2(etapePorteur1, etapePorteur2, distance, quantity); // Calcul pour un camion en groupage
    }
    
    return co2Emission;
  }

  async calculateFullTruckCO2(distance: number): Promise<number> {
    try {
      // Récupérer la consommation du véhicule
      const consoVehiculeResponse = await this.configService.getConfigByKey('conso_vehicule').toPromise();
      const conso_vehicule = consoVehiculeResponse.value;
      //console.log('Conso véhicule:', conso_vehicule);

      // Récupérer l'indice de rejet
      const indiceRejetResponse = await this.configService.getConfigByKey('indice_rejet').toPromise();
      const indice_rejet = indiceRejetResponse.value;
      //console.log('Indice de rejet:', indice_rejet);

      // Calcul du rejet de CO2
      const rejet = (conso_vehicule * distance / 100) * indice_rejet;
      //console.log('Rejet:', rejet);
      return rejet;

    } catch (error) {
      console.error('Erreur lors de la récupération des configs:', error);
      return 0; // Retourner 0 en cas d'erreur
    }
  }

  async calculateGroupedTruckCO2(etapePorteur1: number, etapePorteur2: number, distance: number, qty: number): Promise<number> {
    try {
      // Récupérer la consommation du véhicule
      const consoVehiculeResponse = await this.configService.getConfigByKey('conso_vehicule').toPromise();
      const conso_vehicule = consoVehiculeResponse.value;
      //console.log('Conso véhicule:', conso_vehicule);

      // Récupérer l'indice de rejet
      const indiceRejetResponse = await this.configService.getConfigByKey('indice_rejet').toPromise();
      const indice_rejet = indiceRejetResponse.value;
      //console.log('Indice de rejet:', indice_rejet);

      const consoVehiculePorteurResponse = await this.configService.getConfigByKey('conso_vehicule_porteur').toPromise();
      const conso_vehicule_porteur = consoVehiculePorteurResponse.value;
      //console.log('Conso véhicule Porteur:', conso_vehicule_porteur);

      //Trajet porteur 1
      const percentPalette = qty/20;
      const etape1 = conso_vehicule_porteur * etapePorteur1 / 100 * percentPalette * indice_rejet
      //trajet porteur 2
      const etape2 = conso_vehicule_porteur * etapePorteur2 / 100 * percentPalette * indice_rejet
      //trajet central
      const rejet = (conso_vehicule * distance / 100) * indice_rejet;
      
      const total = etape1 + etape2 + rejet;
      //console.log('Rejet:', total);
      return total;

    } catch (error) {
      console.error('Erreur lors de la récupération des configs:', error);
      return 0; // Retourner 0 en cas d'erreur
    }
  }

  private async calculateDistance(departureCityId: number, arrivalCityId: number): Promise<number> {
    try {
      // Obtenir les coordonnées des villes à partir de leurs IDs
      const coordinates = await this.distanceService.getCoordinatesByCityIds(departureCityId, arrivalCityId);

      //console.log('Coordonnées:', coordinates);
      // Calculer la distance entre les deux villes
      const distance = await this.distanceService.calculateDistance(coordinates.departure, coordinates.arrival);
      //console.log('Distance:', distance);
      return distance;
    } catch (error) {
      console.error('Erreur lors du calcul de la distance', error);
    }
  }
}


// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/co2.service.ts